import React, { useState } from 'react';
import { login, logout } from '../services/api';
import { useNavigate } from 'react-router-dom';

export default function AccessOnboarding(){
  const [email, setEmail] = useState('ava.thompson@acme.co');
  const [password, setPassword] = useState('');
  const [mfa, setMfa] = useState('');
  const [step, setStep] = useState('login');
  const [error, setError] = useState('');
  const [showWizard, setShowWizard] = useState(false);
  const [prefs, setPrefs] = useState({ timezone: 'America/New_York', units: 'metric', theme: 'light' });
  const navigate = useNavigate();

  const submitLogin = async (e) => {
    e.preventDefault(); setError('');
    try{
      const res = await login({ email, password });
      localStorage.setItem('auth_token', res?.token || 'demo-token');
      setStep('mfa');
    }catch(err){ setError(err?.message || 'Login failed'); }
  };

  const submitMfa = (e) => {
    e.preventDefault();
    if((mfa||'').trim().length<4){ setError('Enter a valid MFA code.'); return; }
    setShowWizard(true);
  };

  const finishWizard = () => {
    // In a real app, save preferences via API. Here we just continue.
    setShowWizard(false);
    navigate('/explorer');
  };

  return (
    <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="bg-white border border-gray-200 rounded-xl shadow-xl shadow-gray-200/50 p-6">
        <div className="text-2xl font-extrabold mb-2">Access</div>
        {error && <div className="mb-3 text-sm text-red-600">{error}</div>}
        {step==='login' && (
          <form onSubmit={submitLogin} className="space-y-3">
            <input value={email} onChange={e=>setEmail(e.target.value)} placeholder="Email" className="w-full bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"/>
            <input type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="Password" className="w-full bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"/>
            <button type="submit" className="w-full px-3 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-all">Sign In</button>
            <div className="text-xs text-gray-600 text-center">or sign in with</div>
            <div className="grid grid-cols-2 gap-2">
              <button type="button" className="px-3 py-2 rounded-lg bg-gray-100 border border-gray-200 hover:bg-gray-200 transition-all">SAML</button>
              <button type="button" className="px-3 py-2 rounded-lg bg-gray-100 border border-gray-200 hover:bg-gray-200 transition-all">OIDC</button>
            </div>
          </form>
        )}
        {step==='mfa' && (
          <form onSubmit={submitMfa} className="space-y-3">
            <div className="text-sm text-gray-700">Enter MFA code</div>
            <input value={mfa} onChange={e=>setMfa(e.target.value)} placeholder="123456" className="w-full bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"/>
            <button type="submit" className="w-full px-3 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-all">Verify</button>
          </form>
        )}
      </div>
      <div className="bg-gradient-to-br from-blue-50 via-white to-indigo-50 border border-gray-200 rounded-xl shadow-xl shadow-gray-200/50 p-6">
        <div className="text-lg font-semibold">Enterprise-ready security</div>
        <ul className="mt-2 list-disc list-inside text-sm text-gray-700 space-y-1">
          <li>Single Sign-On (SAML/OIDC)</li>
          <li>Multi-factor authentication</li>
          <li>SCIM provisioning</li>
          <li>Granular RBAC</li>
        </ul>
      </div>

      {showWizard && (
        <div className="fixed inset-0 bg-black/10 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="w-full max-w-lg bg-white border border-gray-200 rounded-2xl shadow-2xl shadow-gray-200/50 p-6">
            <div className="text-xl font-extrabold mb-2">Welcome! Let's personalize your workspace</div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div>
                <label className="text-sm text-gray-700">Time zone</label>
                <input value={prefs.timezone} onChange={e=>setPrefs({ ...prefs, timezone: e.target.value })} className="w-full bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"/>
              </div>
              <div>
                <label className="text-sm text-gray-700">Units</label>
                <select value={prefs.units} onChange={e=>setPrefs({ ...prefs, units: e.target.value })} className="w-full bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500">
                  <option value="metric">Metric</option>
                  <option value="imperial">Imperial</option>
                </select>
              </div>
              <div className="md:col-span-2">
                <label className="text-sm text-gray-700">Theme</label>
                <select value={prefs.theme} onChange={e=>setPrefs({ ...prefs, theme: e.target.value })} className="w-full bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500">
                  <option value="light">Light</option>
                </select>
              </div>
            </div>
            <div className="mt-4 flex gap-2 justify-end">
              <button onClick={()=>{ logout(); localStorage.removeItem('auth_token'); }} className="px-3 py-2 rounded-lg bg-gray-200 text-gray-800 hover:bg-gray-300 transition-all">Sign out</button>
              <button onClick={finishWizard} className="px-3 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-all">Finish</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
